export default __webpack_public_path__ + "static/media/controlPrimaryLocked32.88cc7a82.svg";